import produce from 'immer';
import { SET_CRM_OBJECTS_TO_EDIT, UPDATE_CRM_OBJECT_PROPERTY, FETCH_CRM_OBJECT_FIELD_SCHEMA_SUCCEEDED } from 'ContentEditorUI/redux/actions/actionTypes';
import setIn from 'hs-lodash/set';
export const initialState = {
  crmObjectByKey: {},
  fieldSchema: {}
};
export const crmObjectEditingReducer = (state = initialState, {
  type,
  response,
  payload
}) => produce(state, draft => {
  switch (type) {
    case SET_CRM_OBJECTS_TO_EDIT:
      draft.crmObjectByKey = Object.assign({}, draft.crmObjectByKey, response);
      return draft;
    case UPDATE_CRM_OBJECT_PROPERTY:
      {
        draft.crmObjectByKey = setIn(draft.crmObjectByKey, [...payload.path, 'value'], payload.value);
        return draft;
      }
    case FETCH_CRM_OBJECT_FIELD_SCHEMA_SUCCEEDED:
      if (payload && payload.fieldSchema) {
        draft.fieldSchema = payload.fieldSchema;
      }
      return draft;
    default:
      return draft;
  }
});
export default crmObjectEditingReducer;